export default "__VITE_ASSET__BtXvb7Bw__"